import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { auth } from "../services/api";
import api from "../services/api";

const OAuthSuccess = ({ onLogin }) => {

    const navigate = useNavigate();

    useEffect(() => {

        const processOAuth = async () => {

            try {

                const params = new URLSearchParams(window.location.search);
                const token = params.get("token");

                if (!token) {
                    navigate("/login");
                    return;
                }

                // сохраняем токен
                localStorage.setItem("token", token);

                // получаем пользователя
                const userResponse = await auth.getMe();
                const user = userResponse.data;

                localStorage.setItem("user", JSON.stringify(user));

                // проверяем есть ли сохранённый профиль
                const profile = localStorage.getItem("register_profile");

                if (profile) {

                    const profileData = JSON.parse(profile);

                    try {

                        await api.post("/auth/profile", profileData);

                        console.log("✅ профиль создан");

                    } catch (e) {

                        console.log("⚠️ профиль уже существует");

                    }

                    localStorage.removeItem("register_profile");

                }

                onLogin(user, token);

                navigate("/");

            } catch (err) {

                console.error("OAuth ошибка:", err);

                navigate("/login");

            }

        };

        processOAuth();

    }, [navigate, onLogin]);

    return (
        <div className="loading">
            <div className="spinner"></div>
        </div>
    );

};

export default OAuthSuccess;